<template>
  <div class="industry_module">
    <industry :lists="$attrs.lists" :total="$attrs.total" v-on="$listeners"></industry>
  </div>
</template>

<script>
import Industry from "../../comLeft/industryTab1";

export default {
  components: {
    Industry
  },

  data() {
    return {};
  },

  created() {},

  methods: {}
};
</script>

<style scoped>
.industry_module {
  height: 100%;
}
</style>